import { saveAs } from "file-saver";

export const download = function (data: $TSFixMe, fileName: string, contentType: $TSFixMe) {
  const blob = new Blob([data], { type: contentType });
  saveAs(blob, fileName);
};
